import { Routes } from '@angular/router';
import { LoginGuard } from './guards/login.guard';
import { AuthGuard } from './guards/auth.guard';
import { employeeGuard } from './guards/employee.guard';
import { SidebarGuard } from './guards/sidebar.guard';

export const appRoutes: Routes = [
  {
    path: 'login',
    loadComponent: () =>
      import('./components/login/login.component').then((c) => c.LoginComponent),
    canActivate: [LoginGuard],
  },
  {
    path: 'dashboard',
    loadComponent: () =>
      import('./components/dashboard/dashboard.component').then((c) => c.DashboardComponent),
    canActivate: [AuthGuard, SidebarGuard],
  },
  { path: '', redirectTo: 'dashboard', pathMatch: 'full' },
  {
    path: 'quotations',
    canActivate: [AuthGuard, SidebarGuard],
    children: [
      {
        path: '',
        loadComponent: () =>
          import('./quotation/quotation-list/quotation-list.component').then(
            (c) => c.QuotationListComponent
          ),
      },
      {
        path: 'details',
        loadComponent: () =>
          import('./quotation/quotation-detail/quotation-detail.component').then(
            (c) => c.QuotationDetailComponent
          ),
      },
    ],
  },
  {
    path: 'employees',
    canActivate: [employeeGuard, SidebarGuard],
    children: [
      {
        path: '',
        loadComponent: () =>
          import('./employee/employee-list/employee-list.component').then(
            (c) => c.EmployeeListComponent
          ),
      },
      {
        path: 'details',
        loadComponent: () =>
          import('./employee/employee-detail/employee-detail.component').then(
            (c) => c.EmployeeDetailComponent
          ),
      },
    ],
  },
  {
    path: 'documents',
    canActivate: [AuthGuard, SidebarGuard],
    loadComponent: () =>
      import('./components/document/document.component').then((c) => c.DocumentComponent),
  },
  {
    path: 'job-history',
    canActivate: [AuthGuard, SidebarGuard],
    children: [
      {
        path: '',
        loadComponent: () =>
          import('./quotation/quotation-list/quotation-list.component').then(
            (c) => c.QuotationListComponent
          ),
      },
      {
        path: 'details',
        loadComponent: () =>
          import('./quotation/quotation-detail/quotation-detail.component').then(
            (c) => c.QuotationDetailComponent
          ),
      },
    ],
  },
  {
    path: 'cancelled-jobs',
    canActivate: [AuthGuard, SidebarGuard],
    loadComponent: () =>
      import('./quotation/quotation-list/quotation-list.component').then(
        (c) => c.QuotationListComponent
      ),
  },
  {
    path: 'profile',
    canActivate: [AuthGuard, SidebarGuard],
    loadComponent: () =>
      import('./profile/my-profile/my-profile.component').then((c) => c.MyProfileComponent),
  },
  {
    path: 'reviews',
    canActivate: [AuthGuard, SidebarGuard],
    loadComponent: () =>
      import('./components/review-list/review-list.component').then((c) => c.ReviewListComponent),
  },
  {
    path: 'chat',
    canActivate: [AuthGuard, SidebarGuard],
    loadComponent: () =>
      import('./components/chat/chat.component').then((c) => c.ChatComponent),
  },
  {
    path: 'orders',
    canActivate: [AuthGuard, SidebarGuard],
    children: [
      {
        path: '',
        loadComponent: () =>
          import('./components/product/orders/orders.component').then((c) => c.OrdersComponent),
      },
      {
        path: 'details/:id',
        loadComponent: () =>
          import('./components/product/orders/order-detail/order-detail.component').then(
            (c) => c.OrderDetailComponent
          ),
      },
    ],
  },
  {
    path: 'menu',
    canActivate: [AuthGuard, SidebarGuard],
    children: [
      {
        path: '',
        loadComponent: () =>
          import('./components/product/menu/menu.component').then((c) => c.MenuComponent),
      },
    ],
  },
  {
    path: 'products',
    canActivate: [AuthGuard, SidebarGuard],
    children: [
      {
        path: '',
        loadComponent: () =>
          import('./components/product/product-list/product-list.component').then(
            (c) => c.ProductListComponent
          ),
      },
      {
        path: 'details/:id',
        loadComponent: () =>
          import('./components/product/product-detail/product-detail.component').then(
            (c) => c.ProductDetailComponent
          ),
      },
    ],
  },
  {
    path: 'discounts',
    canActivate: [AuthGuard, SidebarGuard],
    loadComponent: () =>
      import('./components/discounts/discounts-shell.component').then(
        (c) => c.DiscountsShellComponent
      ),
    children: [
      {
        path: '',
        loadComponent: () =>
          import('./components/discounts/discounts-hub/discounts-hub.component').then(
            (c) => c.DiscountsHubComponent
          ),
      },
      {
        path: 'percentage',
        loadComponent: () =>
          import(
            './components/discounts/percentage-discount-setup/percentage-discount-setup.component'
          ).then((c) => c.PercentageDiscountSetupComponent),
      },
      {
        path: 'flat',
        loadComponent: () =>
          import('./components/discounts/flat-discount-setup/flat-discount-setup.component').then(
            (c) => c.FlatDiscountSetupComponent
          ),
      },
      {
        path: 'active',
        loadComponent: () =>
          import('./components/discounts/discounts-active/discounts-active.component').then(
            (c) => c.DiscountsActiveComponent
          ),
      },
    ],
  },
  {
    path: 'ratings-reviews',
    loadComponent: () =>
      import('./components/ratings-reviews/ratings-reviews.component').then(
        (c) => c.RatingsReviewsComponent
      ),
    canActivate: [AuthGuard, SidebarGuard],
  },
  {
    path: 'my-earnings',
    loadComponent: () =>
      import('./components/my-earnings/my-earnings.component').then((c) => c.MyEarningsComponent),
    canActivate: [AuthGuard],
  },
  {
    path: 'store-profile',
    canActivate: [AuthGuard, SidebarGuard],
    loadComponent: () =>
      import('./profile/store-profile/store-profile.component').then(
        (m) => m.StoreProfileComponent
      ),
  },
  {
    path: 'store-front-banners',
    canActivate: [AuthGuard, SidebarGuard],
    loadComponent: () =>
      import('./components/store-promotion-banner/store-promotion-banner.component').then(
        (c) => c.StorePromotionBannerComponent
      ),
  },
  {
    path: 'appearance',
    canActivate: [AuthGuard, SidebarGuard],
    children: [
      {
        path: '',
        loadComponent: () =>
          import('./components/appearance/appearance.component').then(
            (c) => c.AppearanceComponent
          ),
      },
      {
        path: 'details/:id',
        loadComponent: () =>
          import('./components/appearance/appearance-detail/appearance-detail.component').then(
            (c) => c.AppearanceDetailComponent
          ),
      },
    ],
  },
  {
    path: 'help',
    canActivate: [AuthGuard],
    children: [
      {
        path: '',
        loadComponent: () =>
          import('./components/help/help.component').then((c) => c.HelpComponent),
      },
      {
        path: ':slug',
        loadComponent: () =>
          import('./components/help/help-detail/help-detail.component').then(
            (c) => c.HelpDetailComponent
          ),
      },
    ],
  },
  {
    path: 'faqs',
    canActivate: [AuthGuard],
    loadComponent: () => import('./components/faqs/faqs.component').then((c) => c.FaqsComponent),
  },
  {
    path: 'legal',
    canActivate: [AuthGuard],
    loadComponent: () => import('./components/legal/legal.component').then((c) => c.LegalComponent),
  },
  { path: '**', redirectTo: 'dashboard' },
];
